import React from "react";
import {
  answerTypes,
  getType,
  extractNameFromBase64File
} from "./review-step-utils";
import { useTranslation } from "react-i18next";
import injectSheet from "react-jss";

import DescriptionList from "customization/ui/DescriptionListResponsive";
import Section from "./Section";
import { Link } from "react-router-dom";
import { SESSION_CAM_HIDE_TEXT } from "constants/sessioncam";
const { Term, Definition, Row, Header } = DescriptionList;
const style = ({ theme }) => ({
  link: {
    "&:hover $icon": {
      fill: theme.colors.linkHover
    },
    color: "#257886",
    textDecoration: "none"
  },
  icon: {
    lineHeight: 0,
    fill: theme.colors.white
  },
  text: {
    fontWeight: "bold",
    lineHeight: 0,
    marginRight: theme.padding["2"],
    fontSize: "14px"
  },
  body: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }
});
const AnswerTitle = injectSheet(style)(({ to, children, classes }) => {
  const { t } = useTranslation();
  return (
    <Link
      to={{ pathname: to, state: { scrollIntoView: true } }}
      className={classes.link}
    >
      <span className={classes.text}>{t("list.item.change.label")}</span>
    </Link>
  );
});
export const AnswerObject = ({ title, value, url, ...rest }) => {
  return (
    <>
      {title ? (
        <Section>
          <DescriptionList zebra balanced>
            <Header>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between"
                }}
              >
                {title}
                <AnswerTitle to={url}></AnswerTitle>
              </div>
            </Header>
            {Object.entries(value).map(([title, value]) => (
              <Answer title={title} value={value} key={title} {...rest} />
            ))}
          </DescriptionList>
        </Section>
      ) : (
        Object.entries(value).map(([title, value]) => (
          <Answer title={title} value={value} key={title} {...rest} />
        ))
      )}
    </>
  );
};

export const AnswerArray = ({ title, value, ...rest }) =>
  value.map((answer, index) => (
    <div style={{ marginBottom: 36 }} key={index}>
      <DescriptionList zebra balanced>
        <Header>
          {title} {index + 1}
        </Header>
        <Answer title={answer.title} value={answer} key={index} />
      </DescriptionList>
    </div>
  ));

// TODO: Print boolean values as strings
export const AnswerPlain = ({ title, value, ...rest }) => (
  <DescriptionList.Row {...rest}>
    <DescriptionList.Term bold>{title}</DescriptionList.Term>
    <DescriptionList.Definition>
      <span
        className={SESSION_CAM_HIDE_TEXT}
        style={{ whiteSpace: "pre-wrap" }}
      >
        {value}
      </span>
    </DescriptionList.Definition>
  </DescriptionList.Row>
);

export const AnswerFile = ({ value, ...rest }) => (
  <Row {...rest}>
    <Term>Filnamn</Term>
    <Definition>
      <span className={SESSION_CAM_HIDE_TEXT}>
        {extractNameFromBase64File(value)}
      </span>
    </Definition>
  </Row>
);

const Answer = ({ title, value = "-", ...rest }) => {
  switch (getType(value)) {
    case answerTypes.UNDEFINED:
    case answerTypes.PLAIN:
      return <AnswerPlain {...rest} key={title} title={title} value={value} />;
    case answerTypes.FILE:
      return <AnswerFile {...rest} value={value} />;
    case answerTypes.OBJECT:
      return <AnswerObject {...rest} key={title} title={title} value={value} />;
    case answerTypes.ARRAY:
      return <AnswerArray {...rest} key={title} title={title} value={value} />;
    default:
      return <div key={title}>not implemented</div>;
  }
};

export default Answer;
